import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoxEditComponent } from './box-edit.component';
import { SvgIconModule } from '../../../../core/components/svg-icon/svg-icon.module';
import { CoreModule } from '@app/core/core.module';
import { PreviewImgModule } from '@app/shared/components/preview-img/preview-img.module';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { SelectFilesComponent } from '@app/shared/components/select-files-popup/select-files.component';
import { MatDialogModule, MatProgressSpinnerModule } from '@angular/material';

@NgModule({
    imports: [
        SvgIconModule,
        CommonModule,
        RouterModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        CoreModule,
        SharedModule,
        PreviewImgModule,
        MatDialogModule,
        MatProgressSpinnerModule
    ],
    entryComponents: [SelectFilesComponent],
    declarations: [BoxEditComponent, SelectFilesComponent],
    exports: [BoxEditComponent, SelectFilesComponent],
    providers: []
})
export class BoxEditModule {}
